<template>
  <div class="col-span-2 sm:col-span-1 pb-14">
    <div class="relative">
      <div class="absolute inset-0 flex items-center" aria-hidden="true">
        <div class="w-full border-t border-gray-300" />
      </div>
      <div class="relative flex justify-start">
        <span class="pr-3 bg-light-grey text-lg font-medium text-vice-teal-700">Now live</span>
      </div>
    </div>
    <div
      class="flex flex-col mt-8 shadow border rounded-lg"
      v-if="Object.keys(this.$page.props.sessions.live_sessions).length"
    >
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <table class="min-w-full divide-y divide-gray-200">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="
                    pl-6
                    py-3
                    text-left text-xxs
                    font-medium
                    text-gray-500
                    uppercase
                    tracking-wider
                  "
                >
                  Title
                </th>
                <th
                  scope="col"
                  class="
                    py-3
                    pr-3
                    text-left text-xxs
                    font-medium
                    text-gray-500
                    uppercase
                    tracking-wider
                  "
                >
                  Started
                </th>
                <th
                  scope="col"
                  class="py-3 text-left text-xxs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Clinician
                </th>
                <th
                  scope="col"
                  class="
                    py-3
                    text-left
                    truncate
                    text-xxs
                    font-medium
                    text-gray-500
                    uppercase
                    tracking-wider
                  "
                >
                  Open Places
                </th>
                <th scope="col" class="relative py-3">
                  <span class="sr-only">Edit</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(session, sessionIdx) in this.$page.props.sessions.live_sessions"
                :key="session.unique_id"
                :class="sessionIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
              >
                <td class="pl-6 py-4 text-xs font-medium text-vice-teal-900">
                  {{ session.title }}
                </td>
                <td class="py-4 text-center whitespace-nowrap text-xs text-gray-500">
                  {{ hoursFormatter(session.details.session_start_by_timezone) }}
                </td>
                <td class="py-4 whitespace-nowrap text-xs text-gray-500">
                  {{ session.details.clinician?.name }}
                </td>
                <td class="py-4 flex gap-2 h-full align-middle items-center">
                  <ViceBadge :amount="session.open_participant_position" icon="UserIcon" indigo />
                  <ViceBadge :amount="session.open_observer_position" icon="EyeIcon" yellow />
                </td>
                <td class="">
                  <a
                    :href="route('session.user.details', session.unique_id)"
                    class="text-gray-500 hover:text-gray-400"
                  >
                    <ChevronRightIcon class="h-4 w-4"></ChevronRightIcon>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="mt-8 text-gray-500 text-center" v-else>No ongoing sessions at the moment.</div>
  </div>
</template>

<script>
import { ChevronRightIcon } from '@heroicons/vue/solid';
import DateFormatMixin from '@/Mixins/DateFormatMixin.vue';
import ViceBadge from '@/Components/Badges/ViceBadge.vue';

export default {
  name: 'LiveNowSessions',
  setup() {
    return {
      userType,
    };
  },
  components: {
    ViceBadge,
    ChevronRightIcon,
  },
  mixins: [DateFormatMixin],
  methods: {},
};
</script>
